// extracted by mini-css-extract-plugin
export default {"separator":"SavedCreditCardPicker-module__separator___1qEw5"};